// Prints several CDB forms (the modal's iframe documents) as one print job: their A4 sheets are
// copied, with the values typed or ticked in them, into a hidden frame that uses the forms' stylesheet.

const escapeHtml = (text) => String(text).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

function copyFieldState(source, clone) {
  const from = source.querySelectorAll("input");
  const to = clone.querySelectorAll("input");
  from.forEach((input, i) => {
    if (!to[i]) return;
    if (input.type === "checkbox" || input.type === "radio") to[i].checked = input.checked;
    else to[i].value = input.value;
  });
}

/** Hidden frame holding the sheets of all `docs`, ready to print. */
export async function buildCdbFormsPrintFrame(docs, title = "CDB forms") {
  const frame = document.createElement("iframe");
  frame.setAttribute("aria-hidden", "true");
  frame.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden";
  document.body.append(frame);

  const base = new URL(`${process.env.PUBLIC_URL || ""}/forms/cdb/`, window.location.origin).href;
  const pd = frame.contentDocument;
  pd.open();
  pd.write(`<!doctype html><html lang="en"><head><meta charset="utf-8"><title>${escapeHtml(title)}</title>` +
    `<base href="${escapeHtml(base)}"><link rel="stylesheet" href="cdb-forms.css"></head>` +
    `<body><main class="sheets"></main></body></html>`);
  pd.close();

  const link = pd.querySelector("link");
  if (!link.sheet) await new Promise((resolve) => { link.onload = resolve; link.onerror = resolve; });

  const host = pd.querySelector(".sheets");
  for (const doc of docs) {
    for (const sheet of doc.querySelectorAll(".sheet")) {
      const clone = pd.importNode(sheet, true);
      copyFieldState(sheet, clone);
      host.append(clone);
    }
  }
  // Rows were laid out in the source forms; wait for the fonts so the copy prints like them.
  await Promise.all(["400", "500"].map((w) => pd.fonts.load(`${w} 10px "CDB Entry"`).catch(() => null)));
  await pd.fonts.ready;
  return frame;
}

export async function printCdbForms(docs, title = "CDB forms") {
  const frame = await buildCdbFormsPrintFrame(docs, title);
  const win = frame.contentWindow;
  const cleanup = () => setTimeout(() => frame.remove(), 500);
  win.addEventListener("afterprint", cleanup, { once: true });
  setTimeout(() => frame.isConnected && frame.remove(), 5 * 60 * 1000);
  win.focus();
  win.print();
}
